import React from 'react'
import { Show, TextField, DateField } from '@refinedev/antd'
import { useShow, useOne } from '@refinedev/core'
import { Typography, Tag } from 'antd'
import type { Tables } from '@muaa/shared'

type MentorshipRequest = Tables<'mentorship_requests'>
type Profile = Tables<'profiles'>

const { Title } = Typography

const STATUS_COLORS: Record<string, string> = {
  pending: 'orange',
  accepted: 'green',
  declined: 'red',
  cancelled: 'default',
}

export function MentorshipRequestShow() {
  const { query } = useShow<MentorshipRequest>()
  const isLoading = query.isLoading
  const record = query.data?.data

  // liveMode 'off': two useOne on the same `profiles` resource otherwise
  // double-subscribe the shared realtime channel and the second `.on()` after
  // `subscribe()` throws, blanking the page (same gotcha as the edit screen).
  const { query: fromQuery } = useOne<Profile>({
    resource: 'profiles',
    id: record?.from_user_id ?? '',
    meta: { idColumnName: 'user_id' },
    liveMode: 'off',
    queryOptions: { enabled: !!record?.from_user_id },
  })

  const { query: toQuery } = useOne<Profile>({
    resource: 'profiles',
    id: record?.to_user_id ?? '',
    meta: { idColumnName: 'user_id' },
    liveMode: 'off',
    queryOptions: { enabled: !!record?.to_user_id },
  })

  return (
    <Show isLoading={isLoading}>
      <Title level={5}>From</Title>
      <TextField value={fromQuery.data?.data?.name ?? record?.from_user_id ?? '—'} />

      <Title level={5}>To</Title>
      <TextField value={toQuery.data?.data?.name ?? record?.to_user_id ?? '(any)'} />

      <Title level={5}>Message</Title>
      <TextField value={record?.message ?? '—'} />

      <Title level={5}>Status</Title>
      {record?.status ? (
        <Tag color={STATUS_COLORS[record.status] ?? 'default'}>{record.status}</Tag>
      ) : (
        <TextField value="—" />
      )}

      <Title level={5}>Created</Title>
      {record?.created_at ? (
        <DateField value={record.created_at} format="MMM D, YYYY h:mm A" />
      ) : (
        <TextField value="—" />
      )}
    </Show>
  )
}
